<template >
    <!-- <v-container fluid fill-height v-bind:style="{'background-image': 'url(' + require('../assets/LoginBackground.jpg') + ')'}"
        > -->
  
    <v-container fluid fill-height>
        <v-btn  class="custom-btn" :ripple="false" text absolute top right>
        <span style="font-size: 12px;margin-right:10px">{{$t('pgLogin.lblLang')}}: </span>
        <language-switcher/>
      </v-btn> 
      <v-btn text class="mt-30" style="text-decoration: underline;"  @click="Login_asDriver()" absolute top left>Login as Driver</v-btn>
        <v-layout align-center justify-center>
            <!-- <v-card width="450px" class="elevation-1 pa-3" color="rgb(0, 0, 0, 0.4)"> -->
            <v-card width="400px" height="440px" class="elevation-1 pa-3" style="border:1px solid grey">
                <v-card-text>
                  <div class="layout column align-center" >
                      <img :src="carslogo" alt="Login Logo" width="300" height="150">
                  <br>
                  <br/>
                  </div>

                  <v-form ma-5>
                    <v-text-field dense outlined autofocus prepend-icon="mdi-account" label="Username" class="pa-0 ma-0 centered-input" v-model="username" @keyup.enter="onLog()"></v-text-field>
                    <v-text-field dense outlined class = "centered-input"  prepend-icon="mdi-lock" label="Password" type="password" v-model="password" @keyup.enter="onLog()"></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-container fluid>
                    <v-row justify="center" >
                      <v-btn  width = "80%" style = "margin-top: -40px" rounded outlined @click="onLog()" :loading="isloggin"><v-icon small> mdi-login</v-icon>&nbsp; {{$t('pgLogin.lblLogin')}} </v-btn> <br>   
                      <span> {{ projectVersion }} Version - ver.2.0.0</span>
                    </v-row> 
                    
                    </v-container>              
                </v-card-actions>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher'
// import swal from 'sweetalert'
import axios from 'axios'
import md5 from 'md5'
import moment from 'moment'
import api from '../api.js'
  export default {
    props: {
      source: String,
    },
    components:{
      LanguageSwitcher
    },
    computed:{

    },
    data: () => ({
      tempInfo: {},

      logform:true,
      username:'',
      password:'',
      myLog:'',
      userTimeIn: '',

      carslogo : '',

      isloggin: false, // 2026-04-16

      projectVersion: process.env.VUE_APP_PROJECT_VERSION
    }),
    created(){
      // this.carslogo = '../cars/image/avatar/cars_icon.png'  //ngix
      this.carslogo = '../image/avatar/cars_icon.png'  //hrdapps59
      
    },
    methods: {

     async Login_asDriver(){  // 2026-04-16

         try{
          this.isloggin = true;
            
              const url = `${this.api}auth/signin`
              await api.post(url, { 
                  username: 'driver_001', 
                  password: md5('driver_001')
              });

               this.isloggin = false;

               let ObjecttoPass = {
                    id: 'driver_001',
                    FirstName: "Drivers",
                    LastName: "Account",
                    FirstNameEng: "Account",
                    LastNameEng: "Drivers"
               }

               this.SET_USER_DETAILS(ObjecttoPass);
               this.$router.replace({name:"about"})

         }catch(err) {
             // check if the users is not yet confirmed in AWS Cognito User pool
            if (err.response && err.response.data.code === 'UserNotConfirmedException') {
              alert(`Please contact administrator, User is not yet verified`);
            } else {
              alert("Login failed: " + (err.response.data.message || "Unknown error"));
            }
            this.isloggin = false;
         }
      },

      // Login_asDriver(){
      //   let ObjecttoPass = {
      //     id: 'driver_001',
      //     FirstName: "Drivers",
      //     LastName: "Account",
      //     FirstNameEng: "Account",
      //     LastNameEng: "Drivers"
      //   }

      //   // console.log(ObjecttoPass  )
      //   this.CHANGE_USER_DATA(  ObjecttoPass );

      //   this.$router.replace({name:"about"})
      // },
      loadData(){
          const url = `${this.api}myLogToday`
          axios.get(url, {
            params:{
              id: this.userData.EmployeeNumber
            }
        }).then( res => {
            this.myLog = res.data
            console.log(this.myLog)
          })
      },
      async onLog(){  // 2026-04-16
         try{
          this.isloggin = true;
           if( this.username && this.password ) {
              
              const url = `${this.api}auth/signin`
              await api.post(url, { 
                  username: this.username, 
                  password: md5(this.password)
              });

               this.isloggin = false;

               // This call will now definitely carry the cookie because it uses the same 'api' instance
               await this.$store.dispatch('fetchUserProfile');

               if( this.userData.isUseCARS == false || this.userData.isUseCARS == undefined ) {
                  this.$router.replace({name:"about"});
                  return;
               }
               
               if (this.userData.FirstName !== 'Admin')
               {
                  this.$router.replace({name:"Regular"})
               }else{
                  this.$router.replace({name:"home"})
               }
           }

           else{
              alert(`Please enter username and password`);
              this.isloggin = false;
              return;
           }
         
         }catch(err) {
             // check if the users is not yet confirmed in AWS Cognito User pool
            if (err.response && err.response.data.code === 'UserNotConfirmedException') {
              alert(`Please contact administrator, User is not yet verified`);
            } else {
              alert( err.response.data.error );
              //alert("Login failed: " + (err.response.data.message || "Unknown error"));
            }
            this.isloggin = false;
         }
      },
      // onLog(){
      //   //login 
      //   if (!this.username || !this.password) {
      //     return false
      //   }
      //   if(md5(this.password) === this.tempInfo.Password){
      //     this.CHANGE_USER_DATA(this.tempInfo)
        
      //     if (this.userData.FirstName !== 'Admin')
      //     {
      //       this.$router.replace({name:"Regular"})
      //     }else{
      //       this.$router.replace({name:"home"})
      //     } 
      //   }
      //   else{
      //     alert('Wrong Username or Password')
      //   }
      // },
      getLogSpecificUser(){
          // const url = `${this.api}getLog/${this.userData.EmployeeNumber}`
            let dateToday = moment().format("YYYY-MM-DD")
            const url = `${this.api}getLog/${this.userData.EmployeeNumber}/${dateToday}`
            axios.get(url).then(res => {
            // this.userTimeIn = res.data.map( rec => rec.timein)
              this.userTimeIn = res.data.timein
            
            })
      },
    }
  }
</script>
<style  >
.centered-input input {
  text-align: center !important;
  font-size: 20px !important;
  font-family:Verdana !important;
}
.roundCard {
  border-radius:25px !important;
}
</style>

    
